import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=915d79a0&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=js&"
export * from "./EmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=915d79a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915d79a0",
  null
  
)

export default component.exports